module.exports = __webpack_public_path__ + "img/football.b4f35212.svg";